export default {
  register: {
    title: 'Sign Up',
    username: 'Username',
    phone: 'Phone Number',
    phoneCode: 'Code',
    email: 'Email',
    password: 'Password',
    captcha: 'Captcha',
    smsCode: 'SMS Code',
    emailCode: 'Email Code',
    verificationCode: 'Email Code',
    invitationCode: 'Invitation Code',
    loading: 'Loading...',
    send: 'Send',
    sendCode: 'Send Code',
    signUp: 'Sign Up',
    contactUs: 'Contact Us？',
    haveAccount: 'Already have account?',
    signIn: 'Sign In',
    loginNow: 'Sign In',
    or: 'OR',
    orSignUpWith: 'Or Sign Up with',
    methodUsername: 'Username',
    methodPhone: 'Phone',
    methodEmail: 'Email',
    codeOptional: 'Code (Optional)',
    privacyPolicy: 'I confirm that I am above 18 years old and accept the',
    privacyPolicyLink: 'Privacy Policy',
    and: 'and',
    termsConditions: 'Terms & Conditions',
    vault: 'Vault',
    receivePromos: 'Receive Email Promos',
    // Errors
    usernameRequired: 'Username is required',
    usernameInvalid: 'Username can only contain letters, numbers and underscores',
    phoneRequired: 'Phone number is required',
    phoneInvalid: 'Invalid phone number format',
    emailRequired: 'Email is required',
    emailInvalid: 'Invalid email format',
    passwordRequired: 'Password is required',
    passwordInvalid: 'Password does not meet requirements',
    captchaRequired: 'Captcha is required',
    smsCodeRequired: 'SMS code is required',
    emailCodeRequired: 'Email code is required',
    privacyPolicyRequired: 'Please accept the Privacy Policy and Terms & Conditions',
    // Password hints
    passwordHintLow: 'At least 6 digits',
    passwordHintMedium: 'At least 6 chars with letters and numbers',
    passwordHintHigh: 'At least 6 chars with letters, numbers and symbols',
    // Format validation
    usernameFormat: 'Only letters, numbers and _',
    emailFormat: 'Invalid email format',
    // Toast messages
    smsCodeSent: 'SMS code sent',
    emailCodeSent: 'Email code sent',
    smsCodeFailed: 'Failed to send SMS code',
    emailCodeFailed: 'Failed to send email code',
    registerSuccess: 'Registration successful',
    registerFailed: 'Registration failed',
    // Google sign in
    signInWithGoogle: 'Sign in with Google+'
  }
};
